export default __webpack_public_path__ + "static/media/onboardingLogo.531cd61b.png";